export const AUTH_ERROR_MESSAGES = {
  LoginFailure: `Nom d'utilisateur ou mot de passe incorrect.`,
  TokenExpired: `Votre session a expiré. Veuillez vous reconnecter.`,
  DefaultFailure:
    `Erreur serveur : veuillez rafraîchir la page et ré-essayer.

    Si cette erreur persiste, merci de contacter votre administrateur.`,
};
